import { connect, ConnectedProps } from 'react-redux'

import HoverIconButton from 'components/accordion/HoverIconButton'
import { RootState } from 'redux/store'

const mapStateToProps = (state: RootState): { controller: RootState['layout']['controller'], actHoverIconMap: RootState['legislation']['actHoverIconMap'] } => ({
  controller: state.layout.controller,
  actHoverIconMap: state.legislation.actHoverIconMap
})

export const connector = connect(mapStateToProps, null)
export type HoverIconButtonContainerProps = ConnectedProps<typeof connector>

export default connector(HoverIconButton)
